import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";

import MainLayoutDetail from "../components/layout/MainLayoutDetail";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import SectionBox from "../components/layout/SectionBox";
import NewsCard from "../components/molecules/NewsCard";
import PageLoader from "../components/atoms/PageLoader";

import { useAuthStore } from "../store/useAuthStore";
import { useNewsStore } from "../store/useNewsStore";

const NewsDetail = () => {
  const { accessToken, type } = useAuthStore();
  const { slug } = useParams();
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const {
    detail,
    items,
    loading,
    fetchNews,
    fetchNewsDetail,
  } = useNewsStore();

  useEffect(() => {
    if (slug) {
      fetchNewsDetail(lang, slug)
      fetchNews(lang, 1); // buat sidebar "Other News"
    }
  }, [slug, lang]);

  const Layout =
    !accessToken
      ? MainLayoutDetail
      : type === "candidate"
      ? MainLayoutUser
      : type === "company"
      ? MainLayoutAdmin
      : MainLayoutDetail;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Failed to copy link");
    }
  };

  if (loading && !detail) {
    return (
      <Layout>
        <PageLoader />
      </Layout>
    );
  }

  if (!detail) {
    return (
      <Layout>
        <PageLoader />
      </Layout>
    );
  }

  const otherNews = items
  .filter((n) => n.slug !== slug)
  .slice(0, 3);


  return (
    <Layout>
      <section className="w-full pt-6 relative">
        <div className="container-section mx-auto px-6">
          <SectionBox
            className="mt-24"
            classNameSub="!mb-0"
            titleAlign="left"
            titleClassName="text-2xl md:text-3xl text-white"
            background="linear-gradient(175deg, #ffffff 100%, #ffffff 100%)"
          >
            {/* IMAGE */}
            {/* <div className="w-full max-w-5xl mx-auto rounded-2xl overflow-hidden mb-10 aspect-[4/3] bg-gray-100">
              <img
                src={detail.image}
                alt={detail.title}
                className="w-full h-full object-cover"
              />
            </div> */}


            <div className="grid grid-cols-1 md:grid-cols-6 gap-12 items-start">

              {/* CONTENT */}
              {/* CONTENT */}
              <div className="md:col-span-4">
                {/* IMAGE */}
                <div className="w-full rounded-2xl overflow-hidden mb-10 aspect-[5/3] bg-gray-100">
                  <img
                    src={detail.image}
                    alt={detail.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <span className="inline-block px-3 py-1 text-sm font-semibold bg-primary text-white rounded-full">
                  {detail.category}
                </span>

                <h1 className="text-black text-3xl font-bold my-4">
                  {detail.title}
                </h1>

                <p className="text-black italic text-sm mb-8">
                  {detail.date}
                </p>

                <p
                  className="prose max-w-none text-justify"
                  dangerouslySetInnerHTML={{ __html: detail.contentHtml }}
                />

                {detail.tags.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-6">
                    {detail.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="text-xs font-medium px-3 py-1 rounded-full bg-gray-100 text-gray-700"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                )}

                <button
                  onClick={handleCopyLink}
                  className="flex items-center gap-2 mt-4 bg-white/90 px-3 py-2 rounded-full shadow"
                >
                  <Share2 size={18} />
                  <span className="text-sm font-medium hidden md:inline">
                    Share
                  </span>
                </button>
              </div>


              {/* SIDEBAR */}
              <aside className="md:col-span-2 md:sticky md:top-28 pl-0 md:pl-8 md:border-l border-t md:border-t-0">

                <h3 className="text-black text-xl font-semibold mb-4 md:mt-0 mt-4">
                  {lang === "id" ? "Berita Lainnya" : "Other News"}
                </h3>

                <div className="grid gap-4">
                  {otherNews.map((news) => (
                    <Link
                      key={news.id}
                      to={`/${lang}/blog/news/${news.slug}`}
                      className="block"
                    >
                      <NewsCard item={news} />
                    </Link>
                  ))}
                </div>

              </aside>
            </div>
          </SectionBox>
        </div>
      </section>

      <ToastContainer position="top-right" autoClose={2000} />
    </Layout>
  );
};

export default NewsDetail;
